export default __webpack_public_path__ + "web/react/components/app-download-promo/image-assets/TABLET.3f08dc3ec247a6a249c5ebab0dffe773.jpg";